import React from 'react'
import moment from 'moment'

import {
    message,
    DatePicker,
    Select,
    Icon,
    Tag,
    Spin,
    Collapse,
    Radio,
} from 'antd'

import InfiniteScroll from 'react-infinite-scroller'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import './styles.scss'

const RadioGroup  = Radio.Group
const RadioButton = Radio.Button

export default class LogsView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            logs: [],
            entities: [],
            users: [],
            page: 0,
            perPage: 20,
            hasMore: true,
            form: {
                fromDate: '',
                toDate: ''
            },
            selected: {
                entities: [],
                users: [],
                fromDate: '',
                toDate: ''
            }
        }
    }

    componentDidMount() {
        CloudFlyerAPI.finance
            .filters()
            .then(({ data }) => {
                this.setState(
                    {
                        loading: false,
                        ...data,
                    },
                    this.onLoadMore
                )
            })
            .catch(() => this.setState({ loading: false }))
    }

    onResult = logs => this.setState({ loading: false, logs })

    onMoreResults = logs => logs.length && this.setState({logs: this.state.logs.concat(logs)})

    onLoadMore = () => {
        const {
            hasMore,
            loading,
            page,
            perPage,
            selected: { fromDate, toDate, entities, users }
        } = this.state

        if (!loading && hasMore) {
            const newPage = page + 1
            this.setState({ page: newPage, loading: true }, () => {
                CloudFlyerAPI
                    .finance
                    .audits(fromDate, toDate, entities, users, perPage * page, perPage)
                    .then(({ data }) => {
                        if (data.length === 0) {
                            this.setState({ hasMore: false, loading: false })
                        } else if (data.length < perPage) {
                            this.setState(
                                {
                                    loading: false,
                                    hasMore: false,
                                    page: newPage,
                                },
                                () => this.onMoreResults(data)
                            )
                        } else {
                            this.setState(
                                { loading: false, page: newPage },
                                () => this.onMoreResults(data)
                            )
                        }
                    })
                    .catch(() => this.setState({hasMore: false, loading: false}))
            })
        }
    }

    onDateRangeChange = e => {
        const newValue = e.target.value
        let newSelected
        switch (newValue) {
            case 'all':
                newSelected = {
                    ...this.state.selected,
                    fromDate: '',
                    toDate: '',
                }
                break
            case 'month':
                newSelected = {
                    ...this.state.selected,
                    fromDate: moment()
                        .startOf('month')
                        .toISOString(),
                    toDate: moment().toISOString(),
                }
                break
            case 'week':
                newSelected = {
                    ...this.state.selected,
                    fromDate: moment()
                        .startOf('week')
                        .toISOString(),
                    toDate: moment().toISOString(),
                }
                break
            case 'today':
                newSelected = {
                    ...this.state.selected,
                    fromDate: moment()
                        .startOf('day')
                        .toISOString(),
                    toDate: moment().toISOString(),
                }
                break
        }

        this.setState({ ...this.state, selected: newSelected }, this.refresh)
    }

    refresh = () =>
        this.setState(
            {loading: false, hasMore: true, page: 0, logs: []},
            this.onLoadMore)

    onChange = (target, newValue) =>
        this.setState({
                selected : {
                    ...this.state.selected,
                    [target]: newValue}
            }, this.refresh)

    render() {
        const { loading, logs, entities, users, hasMore } = this.state
        return (
            <div className="finance-logs-view">
                <div>
                    <h2 className="logs-header">
                        <Icon type="profile" /> Users Activities
                    </h2>
                    <LogsFilter
                        loading={loading}
                        entities={entities}
                        users={users}
                        onResult={this.onResult}
                        onChange={this.onChange}
                        onDateRangeChange={this.onDateRangeChange}/>
                </div>

                <div
                    className="logs-container"
                    ref={ref => (this.scrollParentRef = ref)}>
                    <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={this.onLoadMore}
                        hasMore={!loading && hasMore}
                        useWindow={false}
                        getScrollParent={() => this.scrollParentRef}>
                        <div>
                            {!loading && logs.length === 0 ? (
                                <div className="empty-state">
                                    No Logs To View
                                </div>
                            ) : (
                                <div>
                                    <Collapse
                                        bordered={false}
                                        defaultActiveKey={['0']}>
                                        {logs.map((item, i) => (
                                            <Collapse.Panel
                                                header={
                                                    <Row
                                                        author={item.author}
                                                        username={item.username}
                                                        resource={item.resource}
                                                        entity={item.entity}
                                                        type={item.type}
                                                        created_on={item.created_on}/>
                                                }
                                                key={i.toString()}>
                                                {item.changes.map(change => {
                                                    if (item.type === 'Added') {
                                                        return (
                                                            <AddChange
                                                                property = {change.property}
                                                                value    = {change.value}
                                                                key      = {change.property}/>
                                                        )
                                                    } else if (
                                                        item.type === 'Modified'
                                                    ) {
                                                        return (
                                                            <ModifyChange
                                                                property = {change.property}
                                                                value    = {change.value}
                                                                initial  = {change.initial}
                                                                key      = {change.property}/>
                                                        )
                                                    } else if (
                                                        item.type === 'Deleted'
                                                    ) {
                                                        return (
                                                            <DeleteChange
                                                                property = {change.property}
                                                                value    = {change.value}
                                                                key      = {change.property}
                                                            />
                                                        )
                                                    }
                                                })}
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>
                                    {loading && (
                                        <div className="loading-container">
                                            <Spin />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </InfiniteScroll>
                </div>
            </div>
        )
    }
}

class LogsFilter extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {
            entities,
            users,
            onChange,
            onDateRangeChange,
        } = this.props
        return (
            <div className="logs-filter">
                <Select
                    mode="multiple"
                    placeholder="Entities"
                    onChange={newValue => onChange('entities', newValue)}>
                    {entities.map(entity => (
                        <Select.Option value={entity.value} key={entity.value}>
                            {entity.key}
                        </Select.Option>
                    ))}
                </Select>
                <Select
                    mode="multiple"
                    placeholder="Users"
                    onChange={newValue => onChange('users', newValue)}>
                    {users.map(user => (
                        <Select.Option value={user.value} key={user.value}>
                            {user.key}
                        </Select.Option>
                    ))}
                </Select>
                <RadioGroup
                    onChange={onDateRangeChange}
                    defaultValue="all"
                    className="time-range-select">
                    <RadioButton value="today">Today</RadioButton>
                    <RadioButton value="week">This Week</RadioButton>
                    <RadioButton value="month">This Month</RadioButton>
                    <RadioButton value="all">All</RadioButton>
                </RadioGroup>
            </div>
        )
    }
}

const Row = ({ username, author, resource, entity, type, created_on }) => (
    <div className="row-header">
        <Tag
            className="op-type"
            color={
                type === 'Added' ? 'green' : type === 'Deleted' ? 'red' : 'blue'
            }>
            {type}
        </Tag>
        <span className="date">
            {moment(created_on).format('DD/MM/YYYY HH:mm')}
        </span>
        <span className="author">{author}</span>
        <span className="operation">{type.toLowerCase()}</span>
        <span className="resource">{resource}</span>
        <span className="sep"> - </span>
        <span className="entity">[{entity}]</span>
    </div>
)

const AddChange = ({ property, value }) => (
    <div className="change" key={property}>
        <div className="property">{property}</div>
        <div>
            <div className="new-value">{value}</div>
        </div>
    </div>
)

const ModifyChange = ({ property, initial, value }) => (
    <div className="change" key={property}>
        <div className="property">{property}</div>
        <div className="change-body">
            <div className="old-value">{initial}</div>
            <div> → </div>
            <div className="new-value">{value}</div>
        </div>
    </div>
)

const DeleteChange = ({ property, value }) => (
    <div className="change" key={property}>
        <div className="property">{property}</div>
        <div>
            <div className="old-value">{value}</div>
        </div>
    </div>
)
